import { BaseContainerModel } from '../../base-container.model';
import {bl_fi_mst_entity_account_manager_link_RowClass} from '../../../dbschema';

export class EntityAccountManagerLinkContainerModel extends BaseContainerModel {
  bl_fi_mst_entity_account_manager_link: bl_fi_mst_entity_account_manager_link_RowClass = new bl_fi_mst_entity_account_manager_link_RowClass();
}
